import React from 'react';
import NotFoundBlock from '../components/NotFoundBlock';

function NotFound() {
  return <NotFoundBlock />;
}

export default NotFound;
